module.exports = __webpack_public_path__ + "static/img/9.9bbc4fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/9.jpg
// module id = 7sPo
// module chunks = 1